import { useTranslation } from 'react-i18next';
import './Footer.css';

export function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <img
            src="/logos/ananeos-logo-full-dark-1200.png"
            alt="Ananeos"
            className="footer__logo"
            loading="lazy"
            width="220"
          />
          <p className="footer__tagline">{t('footer.tagline')}</p>
        </div>

        <div className="footer__cols">
          <div className="footer__col">
            <h4 className="footer__heading">{t('footer.products')}</h4>
            <a href="https://meetflow.ananeos.com" target="_blank" rel="noopener noreferrer">MeetFlow</a>
          </div>
          <div className="footer__col">
            <h4 className="footer__heading">{t('footer.company')}</h4>
            <a href="#capabilities">{t('footer.capabilities')}</a>
            <a href="#about">{t('footer.about')}</a>
            <a href="#contact">{t('footer.contact')}</a>
            <a href="#newsletter">{t('footer.newsletter')}</a>
          </div>
        </div>
      </div>
      <div className="container footer__bottom">
        <span>{t('footer.copyright', { year })}</span>
      </div>
    </footer>
  );
}
